module.exports = __webpack_public_path__ + "static/media/skatersWaltz.03605fb5.m4a";